module.exports = __webpack_public_path__ + "static/img/gyhd.6e0bc95.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/gyhd.webp
// module id = ZVb5
// module chunks = 68